import React, {useState} from 'react';
import Rating from '@material-ui/lab/Rating';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Fade from '@material-ui/core/Fade';

const StarsFeedBack = () => {
  const [value, setValue] = useState<number | null>(null);
  const [voted, setVoted] = useState<boolean>(true);
  const onChange = (e: React.ChangeEvent<{}>, value: number | null) => {
    setValue(value);
    setVoted(true);
  };
  const getVotingText = (): string => {
    if (value === null) return `Чи задоволені Ви візитом у "Біокурс"?`;
    if (value === 1) return `Нам прикро про це чути.`;
    if (value === 5) return `Ми раді що вам все сподобалося.`;
    return `Дякуємо за відгук!`;
  };
  return (
    <Fade in={voted} timeout={1000}>
      <Box component="fieldset" mb={3} mt={2} borderColor="transparent">
        <Typography component="legend">{getVotingText()}</Typography>
        <Rating
          name="simple-controlled"
          value={value}
          onChange={onChange}
        />
      </Box>
    </Fade>
  );
};

export default StarsFeedBack;
